var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlertOff(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "alert-off_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 0H2v20h20V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#alert-off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.142 17.502a3.17 3.17 0 01-1.12 1.798 3.305 3.305 0 01-4.07 0 3.091 3.091 0 01-1.12-1.798h6.31zM11.987.012c4.056 0 7.39 2.911 7.7 6.696v.275l.025.275v4.51l1.224 3.235.038.1.026.113v.112c0 .4-.245.737-.67.887l-.141.037H3.953a.993.993 0 01-.335-.062.92.92 0 01-.618-.9v-.15l.051-.162 1.224-3.223V6.958C4.429 3.061 7.84 0 11.987 0v.012z",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertOff);
export default ForwardRef;